import React from 'react'
import { ContentModuleProps } from '~types'
import ContentModuleSection from '../ContentModuleSection/ContentModuleSection'

const ContentModule = ({ moduleSections }: ContentModuleProps) => {
  return (
    <>
      {moduleSections &&
        moduleSections.length > 0 &&
        moduleSections.map((moduleSection, index) => <ContentModuleSection {...moduleSection} key={index} />)}
    </>
  )
}

export default ContentModule
